<template>
  <div>KWT v{{ appVersion }} (build {{ buildNum }})</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('application', ['appVersion', 'buildNum'])
  }
};
</script>

<style lang="scss" scoped>
div {
  text-align: center;
  padding: 10px;
  color: black;
  font-size: 12px;
  padding: 20px 0 10px;
  margin-bottom: auto;
}
</style>
